// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__3rD4L","topBottomGutter":"Layout_topBottomGutter__3gnQ7"};